import { formatDateRu, replaceIsoDatesInText } from "./dateFormat";

const CALENDAR_TYPE_LABEL = {
    birthday: "День рождения",
    child_birthday: "День рождения ребенка",
    family_birthday: "День рождения родственника",
    work_anniversary: "Годовщина работы",
    interview: "Собеседование",
    permanent: "Постоянное",
    other: "Другое событие",
};

function localizeCalendarTitle(title) {
    const source = String(title || "").trim();
    const match = source.match(/^([a-z_ ]+?)(?:\s*:\s*(.+))?$/i);
    if (!match) return source;

    const key = match[1].trim().toLowerCase().replace(/\s+/g, "_");
    const label = CALENDAR_TYPE_LABEL[key];
    if (!label) return source;

    const entity = String(match[2] || "").trim();
    return entity ? `${label}: ${entity}` : label;
}

export function normalizeDashboardTask(task) {
    if (!task || typeof task !== "object") return task;
    const out = { ...task };
    out.description = replaceIsoDatesInText(out.description);
    out.meta = replaceIsoDatesInText(out.meta);
    out.title = localizeCalendarTitle(out.title);

    if (out.meta && /^\d{4}-\d{2}-\d{2}$/.test(String(out.meta))) {
        out.meta = formatDateRu(out.meta);
    }
    return out;
}
